<template>
  <nav class='un_categorynav'>
      <a class='cat_nav-header cur_p' tag='div' href='/'>
        <h2><GrLogo class='admin_logo' /><span>Uncommon</span></h2>
      </a>

    <div
      class='un_menuitem_container'
      v-if='$route.name !== "designer-view"'>
      <Category
        v-for='(category, i) in categories'
        :category='category'
        :key='i'/>
    </div>
  </nav>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import GrLogo from '$svgs/GrLogo.vue'
import Category from './Category.vue'
export default {
  props: [
    'env'
  ],

  computed: {
    ...mapState('system', ['categories'])
  },

  methods: {
    ...mapActions('system', ['getCategories'])
  },

  mounted () {
    this.getCategories()
  },

  components: {
    Category,
    GrLogo
  }
}
</script>
<style lang='scss'>
.un_categorynav{
  @include full_wh;
  position:fixed;
  width:$s_globalnav_w;
  overflow-y:scroll;
  background-color: #eeeef5;
  box-shadow: $shadow_gold-item-nav;
  .cat_nav-header{
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:5rem;
    padding:2rem;
    padding-top: 3rem;
    text-decoration: none;
  }
  h2{
    // color:#aaaaca;
    @include font-size(1.3);
    @include type_black;
    color: #1e1e6b;
    // text-transform: uppercase;
  }
  .admin_logo{
    width: 1.9rem;
    height: 1.7rem;
    display: inline-block;
    vertical-align: middle;
    margin-right: 1rem;
  }
  .un_menuitem_container{
    position: relative;
    margin-top: 10rem;
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/gold-admin/CategorySelection.vue